import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../auth.service';
import { ResetRequest } from './reset-request.model';

@Component({
    selector: 'app-reset-request',
    templateUrl: './reset-request.component.html',
    styleUrls: ['./reset-request.component.scss'],
    standalone: false
})
export class ResetRequestComponent implements OnInit, AfterViewInit {
  resetRequestForm: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  error: string = null;
  resetRequestComplete: boolean = false;
  failureClosed: boolean = true;
  isEmail: boolean = true;
  phoneNumber: string = '';
  dial_code: string = '';
  reset_token: string = '';
  verifyPhone: boolean = false;
  failedToVerify: boolean = false;
  subdomain: string = "";

  constructor(
    private authService: AuthService,
    public globalService: GlobalService,
    private tenantService: TenantService,
    private _router: Router,
  ) { }

  async ngOnInit() {
    var simple = await this.tenantService.getSimpleTenant();
    this.subdomain = simple.subdomain;
    this.dial_code = simple.dialCode.toString();
    this.isLoading = true;
    this.resetRequestForm = new FormGroup({
      email: new FormControl(null, [Validators.required]),
    });
    this.resetRequestForm.reset();

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = "";
    });
  }      


  clearCellPhone() {   
    this.reloadCurrentRoute();
  }

  reloadCurrentRoute() {
    const currentUrl = this._router.url;
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([currentUrl]);
    });
  }  

  failedVerification() {
      this.verifyPhone = false;
      this.failedToVerify = true;
  }

  ConfirmCellPhone(phoneNumber)
  {
    const resetRequest: ResetRequest = {
      email: this.phoneNumber,
    };
    this.authService.getPhoneResetToken(resetRequest).subscribe(
      (data) => {
        this.reset_token = data['token'];
        var encodedPhone = encodeURIComponent(this.phoneNumber).replace('%20','+');
        var encodedToken = encodeURIComponent(this.reset_token).replace('%20','+');
        this._router.navigateByUrl(this.subdomain + '/resetpassword/'+ encodedPhone + '/' + encodedToken);
      }
    )
  }

  onSubmit() {
    if (!this.resetRequestForm.valid) {
      this.failureClosed = false;
      return;
    }

    var email = this.resetRequestForm.get('email').value;

    if (email.indexOf('@') >= 0)
      this.isEmail = true;
    else {
      this.isEmail = false;
      this.phoneNumber = email.replace(/\D/g, "");
    }

    const resetRequest: ResetRequest = {
      email: email,
    };
    if (this.isEmail == true)
      this.authService.requestReset(resetRequest).subscribe(
        (data) => {
          this.resetRequestComplete = true;
          this.error = null;
          this.failureClosed = true;
          this.isLoading = false;
        },
        (errorMessage) => {
          this.error = errorMessage.message;
          this.resetRequestComplete = false;
          this.failureClosed = false;
          this.isLoading = false;
        }
      );
    else
    {
      this.error = null;
      this.verifyPhone = true;
      this.failureClosed = true;
    }
  }
}
